import React, { useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userInfo } from './data/atom';
import { URL } from './data/url';
import Layout from './Layout';
import Manual from './pages/manual';
import Unit from './pages/unit';
import Vocabulary from './pages/vocabulary';
import Manage from './pages/manage';

function Router() {
  const { isLoggedIn } = useRecoilValue(userInfo);
  const navigate = useNavigate();

  useEffect(() => {
    // if (isLoggedIn) {
    //   navigate('/manage', { replace: true });
    // }
  }, [isLoggedIn, navigate]);

  return (
    <Routes>
      {isLoggedIn ? (
        <Route path={URL.Root} element={<Layout />}>
          <Route path={URL.Root} element={<Manual />} />
          <Route path={URL.Unit} element={<Unit />} />
          <Route path={URL.Vocabulary} element={<Vocabulary />} />
          <Route path={URL.Manage} element={<Manage />} />
        </Route>
      ) : (
        <>
          {/* <Route path={Url.Root} element={<Login />} /> */}
          <Route path="*" element={<Navigate to={URL.Root} />} />
        </>
      )}
    </Routes>
  );
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
}
